import './Select.scss'

export const Select: React.FC<SelectProps> = ({
  options,
  instructions,
  value,
  onChange,
  id,
  full = false,
  theme = 'v1',
  ...selectProps
}) => {
  return (
    <div
      className={`CLSelect ${
        full ? 'CLSelect--full' : 'CLSelect--fit'
      } TWTheme--${theme}`}
    >
      <select
        id={id}
        className="CLSelect__input"
        value={value}
        onChange={onChange}
        {...selectProps}
      >
        {instructions ? (
          <option value="" disabled>
            {instructions}
          </option>
        ) : null}
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
